export const apiURI =
  process.env.NODE_ENV === "production" && process.env.AGATHO_WEBINY_PRODUCTION_OVERRIDE === "false"
    ? "http://localhost:3000/dev"
    : "http://localhost:3000/dev";
    // ? "https://agatho-dev.hertz.asiapac.io"
    // : "https://agatho-dev.hertz.asiapac.io";

export const apiAuthURI = `${apiURI}/auth`;

export const apiGraphQLURI = `${apiURI}/api`;

export const apiDocumentURI = `${apiURI}/document`;

export const apiNotificationURI = `${apiURI}/notification`;

export const googleAnalyticsURI =
  process.env.NODE_ENV === "production" ? "UA-147904720-1" : "UA-192146065-1";

export const node_env = process.env.NODE_ENV;

export const enableDemo = false;

export const enableInternationalOcrFlow = true;

export const athenaURL =
  process.env.NODE_ENV === "production"
    ? "https://athena.hertz.asiapac.io"
    : "https://athena.hertz.asiapac.io";

export const rentalManageURL =
  process.env.NODE_ENV === "production"
    ? "https://rental-extension-prod.hertz.asiapac.io"
    : "https://rental-extension-prod.hertz.asiapac.io";

export const fileURL =
  process.env.NODE_ENV === "production"
    ? //"http://localhost:3000"
      //: "http://localhost:3000";
      "https://file-prod.hertz.asiapac.io"
    : "https://file-prod.hertz.asiapac.io";
